var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "limit-box" }, [
    _c(
      "span",
      { staticClass: "limit-btn", on: { click: _vm.handleDecrease } },
      [_vm._v("-")]
    ),
    _c("span", { staticClass: "limit-value" }, [_vm._v(_vm._s(_vm.value))]),
    _c(
      "span",
      { staticClass: "limit-btn", on: { click: _vm.handleIncrease } },
      [_vm._v("+")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }